import { useEffect, useState } from 'react';
import { IData } from 'types/orders';
import { getI18nKeySafe } from 'utils/configurations';
import { CONFIGURATION_FIELDS_NAME, TConfigFieldName } from 'constants/configurations.constants';
import NudosButton from 'components/NudosComponents/NudosButton/NudosButton';
import './ConfigurationCommentsModalContent.scss';

const ConfigurationCommentsModalContent = ({
  comments,
  configData,
  configClassId,
  isAdditionalSettingsInOrders,
  closeModalCallback
}: {
  comments: string;
  configData?: IData[] | null;
  configClassId?: number | null;
  isAdditionalSettingsInOrders?: boolean;
  closeModalCallback: () => void;
}) => {
  const configurationDetailsText = 'Detalles de la configuración';

  const [listableFields, setListableFields] = useState<IData[]>(configData || []);

  const isFieldFileUrl = (fieldName: string) => {
    return CONFIGURATION_FIELDS_NAME[fieldName as TConfigFieldName] === CONFIGURATION_FIELDS_NAME.FileUrl;
  };

  const isFieldComment = (fieldName: string) => {
    return CONFIGURATION_FIELDS_NAME[fieldName as TConfigFieldName] === CONFIGURATION_FIELDS_NAME.Comments;
  };

  const configurationFields = {
    unknownField: 'Campo desconocido',
    dep: {
      companyAppleId: 'Company Apple ID',
      emailAppleAccount: 'Correo Apple Account',
      companyName: 'Nombre de la empresa'
    },
    appleCarePlus: {
      comments: 'Comentarios'
    },
    mdmEnrollment: {
      comments: 'Comentarios',
      fileUrl: 'Prueba de configuración (PDF o JPG)'
    },
    appleConfigurator: {
      appleConfiguratorUser: 'Usuario',
      appleConfiguratorPassword: 'Contraseña',
      appleConfiguratorPhone: 'Número de teléfono para SMS'
    },
    hashId: {
      comments: 'Comentarios'
    },
    createAdmin: {
      adminName: 'Usuario',
      adminPassword: 'Contraseña',
      askQuestions: 'Preguntas de seguridad'
    },
    encryptBitlocker: {
      comments: 'Comentarios'
    },
    advancedConfiguration: {
      comments: 'Comentarios',
      fileUrl: 'Prueba de configuración (PDF o JPG)'
    },
    accidentalWarranty1Year: {
      comments: 'Comentarios'
    },
    extendedWarranty3Years: {
      comments: 'Comentarios'
    }
  };
  const getConfigFieldTranslation = (fieldName?: string) => {
    const key = getI18nKeySafe(configClassId, fieldName);

    if (key === 'unknownField') {
      return configurationFields.unknownField;
    }

    const [configClass, configField] = key.split('.');

    const configClassFields = configurationFields[configClass as keyof typeof configurationFields] as
      | Record<string, string>
      | undefined;
    if (configClassFields && typeof configClassFields === 'object') {
      return configClassFields[configField] || configurationFields.unknownField;
    }

    return configurationFields.unknownField;
  };

  const getCommentsType = () => {
    if (!isAdditionalSettingsInOrders) return <div className="commentTextStyles">{comments}</div>;

    const isUniqueComment = listableFields?.length === 1 && listableFields?.find(item => isFieldComment(item?.name));
    if (isUniqueComment) {
      return <div className="commentTextStyles">{listableFields[0].value}</div>;
    }

    return (
      <div className="commentTextStyles">
        <ul className="listStyle">
          {listableFields?.map(item => {
            return (
              <li key={item?.name}>
                <span className="titleList">{getConfigFieldTranslation(item.name)}: </span>
                {item?.value}
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  useEffect(() => {
    const listableFields = configData?.filter(item => !isFieldFileUrl(item.name));
    setListableFields(listableFields || []);
  }, [configData]);

  return (
    <div className="configurationCommentsModalContent">
      <div className="configurationCommentsModalContentMain">
        <div className="configurationCommentsTitle">{configurationDetailsText}</div>
        {getCommentsType()}
      </div>

      <div className="containerButton">
        <NudosButton
          componentSize="small"
          buttonText="Cerrar"
          handleClick={closeModalCallback}
          colorPalette="primary"
        />
      </div>
    </div>
  );
};

export default ConfigurationCommentsModalContent;
